const errorTexts = {
	unknownError: {
		da: 'Fejl: Ukendt fejl.',
		en: 'Error: Unknown error.'
	},
	invalidEmail: {
		da: 'Fejl: Din email er ikke gyldig.',
		en: 'Error: Your e-mail is invalid.'
	},
	emailNotFound: {
		da: 'Fejl: Der findes ingen bruger med denne email.',
		en: 'Error: There is no user with that e-mail.'
	},
	invalidEmailPassword: {
		da: 'Fejl: Check om din e-mail og password er korrekte.',
		en: 'Error: Check if your e-mail and password are correct.'
	},
	missingFields: {
		da: 'Fejl: Husk at udfylde alle felter.',
		en: 'Error: Remember to fill out all fields.'
	},
	differentPasswords: {
		da: 'Fejl: Passwords er ikke ens',
		en: 'Error: Passwords do not match'
	},
	gameDoesNotExist: {
		da: 'Der eksisterer ikke noget spil på denne adresse.',
		en: 'There is no game available on this address.'
	},
	groupNameTooShort: {
		da: 'Fejl: Dit gruppenavn skal være på mindst %minChars% karakterer.',
		en: 'Error: Your group name must be at least %minChars% characters long.'
	},
	groupNameTooLong: {
		da: 'Fejl: Dit gruppenavn må max være på %maxChars% karakterer.',
		en: `Error: Your group name cannot be longer than %maxChars% characters.`
	},
	groupAlreadyExists: {
		da: 'Fejl: Der eksisterer allerede en gruppe med dette navn.',
		en: 'Error: There is already a group with this name.'
	}
};

const cookieTexts = {
	text1: {
		da: `Må vi gemme et par cookies?
			<br /><br />Du kan ikke spille uden. Tryk "JA" for at acceptere dem.`,
		en: `May we save a few cookies?
			<br /><br />It is not possible to play without them. Press "YES" to accept them.`
	},
	text2: {
		da: `<br />Vi vil gerne gemme 2 cookies: En der husker, at du har sagt ja til cookies, og en anden, der husker dit login.
			<br /><br />Trykke "NEJ" for at slette alle cookies og trække dit samtykke tilbage.`,
		en: `<br />We want to save 2 cookies: One that remembers, that you have accepted our use of cookies, and another that remembers your login.
			<br /><br />Press "NO" to delete all cookies and withdraw you acceptance.`
	},
	seeMore: {
		da: 'Se mere',
		en: 'Read more'
	},
	seeLess: {
		da: 'Se mindre',
		en: 'Read less'
	},
	yes: {
		da: 'Ja',
		en: 'Yes'
	},
	no: {
		da: 'Nej',
		en: 'No'
	}
}

const pageTexts = {
	gameStartWelcome: {
		da: 'Tryk på "Start nyt spil" for at komme i gang.',
		en: `Press "Start new game" to get started.`
	},
	gameStartDescription: {
		da: 'Vælg om du vil fortsætte et igangværende spil eller starte et nyt.',
		en: `Choose whether you want to continue a current game or start a new one.`
	},
	chooseBranchTitle: {
		da: 'Velkommen',
		en: 'Welcome'
	},
	chooseBranchText: {
		da: 'Vælg branche for at starte nyt spil:',
		en: `Select an industry to start a new game:`
	},
	introVideoText: {
		da: 'Se explainer-videoen',
		en: 'Watch the explainer video'
	},
	chooseThemeText: {
		da: 'Vælg det tema I skal arbejde med i dag',
		en: `Choose the topic you’ll be working on today.`
	},
	introTitle: {
		da: 'Præsentation af temaet',
		en: `Presentation of the theme`
	},
	groupsTitle: {
		da: 'Lad os komme i gang!',
		en: `Let’s get started!`
	},
	groupsText1: {
		da: `<ol>
			<li>Del jer i grupper af 2-3 personer </li>
			<li>Én fra hver gruppe scanner QR-koden med en telefon.</li>
			<li>Gå ud i jeres grupper</li>
		</ol>`,
		en: `<ol>
			<li>Split into groups of 2–3 people </li>
			<li>One person from each group should scan the QR code using a mobile phone.</li>
			<li>Go out in your groups</li>
		</ol>`
	},
	groupsText2: {
		da: 'Klik på "Næste", når én fra hver gruppe har scannet koden.',
		en: `Click "Next" once one person from each group has scanned the code.`
	},
	gameStatusTitle: {
		da: 'Overblik over grupper',
		en: `Overview of groups`
	},
	gameStatusText1: {
		da: 'Se hvor langt grupperne er kommet.',
		en: `See how far the groups have come.`
	},
	gameStatusText2: {
		da: 'Klik på "Se svar", når alle grupper har gennemført forløbet.',
		en: `Click on "View answers" once all groups have completed the course.`
	},
	gameResultsIntroTitle: {
		da: 'Lad os se på jeres svar!',
		en: `Let’s take a look at your answers!`
	},
	gameResultsIntroText: {
		da: `Det næste I skal er at:
			<ol>
				<li>se på svarene sammen</li>
				<li>tale med jeres sidemakker om svarene</li>
				<li>vælge et eksperiment eller en fælles handling, I vil afprøve</li>
			</ol>`,
		en: `The next thing you need to do is:
			<ol>
				<li>look at the answers together</li>
				<li>discuss the answers with your neighbour</li>
				<li>choose an experiment or shared action you want to try out</li>
			</ol>`
	},
	saveResults: {
		da: 'Gem resultater',
		en: 'Save results',
	},
	gameResultsOutro: {
		title: {
			da: `Tal om svarene`,
			en: `Talk about the answers`
		},
		text: {
			da: `Tal i to minutter med din sidemakker om resultaterne. Hvad tænker du om resultaterne? Er der noget, der overrasker jer?`,
			en: `Spend two minutes discussing the results with the person sitting next to you. What do you think of the results? Is there anything that surprises you?`
		},
		btn: {
			da: 'Se svar',
			en: 'See answers'
		}
	},
	experimentsTitle: {
		da: `Find på et eksperiment`,
		en: `Come up with an experiment`
	},
	experimentsText: {
		da: `Tal med din sidemakker om et eksperiment eller en fælles handling, I kunne tænke jer at afprøve den næste måned.
			<br /><br />I kan få inspiration her:`,
		en: `Talk to the person sitting next to you about an experiment or shared action you’d like to try out over the next month.
			<br /><br />You can find inspiration here:`
	},
	experimentsCustom: {
		da: `Find på dit eget`,
		en: 'Come up with your own'
	},

	experimentPresentationTitle: {
		da: `Vælg et eksperiment`,
		en: `Choose an experiment`
	},
	experimentPresentationText: {
		da: `Del jeres bud på eksperimenter eller fælles handling med resten. Gennemgå dem alle et ad gangen. Nu skal I stemme på, hvad I vil afprøve den næste måned. Det foregår via håndsoprækning.`,
		en: `Share your ideas for experiments or shared actions with the rest of the group. Go through all the experiments one by one. Now you need to vote on which experiment you want to try out next month. This will be done by a show of hands.`
	},

	gameEndTitle: {
		da: 'Opsamling',
		en: 'Wrap-up'
	},
	gameEndText: {
		da: `Nu har I været igennem spillet og valgt et eksperiment, som I skal afprøve den næste måned. Inden I går ud ad døren, skal I have på plads:`,
		en: `You’ve now gone through the game and chosen an experiment to try out over the next month. Before you leave, you need to have the following sorted:`
	},
	gameEndItems: [
		{
			da: `Hvilket eksperiment eller hvilken fælles handling I har valgt`,
			en: `Which experiment or shared action you’ve chosen`
		},
		{
			da: `Dato og tidspunkt for opfølgning af eksperiment`,
			en: `The date and time for following up on the experiment`
		}
	]
};

	/* GROUP */
	const groupTexts = {
		welcomeTitle: {
			da: 'Velkommen',
			en: `Welcome`
		},
		welcomeText: {
			da: `Find et sted at sidde som gruppe.
				<br /><br />Tryk på "Start", når I er klar.`,
			en: `Find a place for the group to sit.
				<br /><br />Tap "Start" when you're ready.`
		}
	}

const generalTexts = {
	title: {
		da: 'Holdspillet!',
		en: 'Holdspillet!'
	},
	subtitle: {
		da: 'Spil hinanden gode',
		en: 'Spil hinanden gode'
	},

	start: {
		da: 'Start',
		en: `Start`
	},
	loadingGame: {
		da: 'Henter spil',
		en: `Loading game`
	},
	continueGame: {
		da: 'Fortsæt spil',
		en: `Continue game`
	},
	newGame: {
		da: 'Start nyt spil',
		en: `Start new game`
	},
	login: {
		da: 'Log ind',
		en: 'Log in'
	},
	logout: {
		da: 'Log ud',
		en: 'Log out'
	},
	loading: {
		da: 'Loading',
		en: 'Loading'
	},
	resetPasswordTitle: {
		da: 'Gendan password',
		en: 'Reset password'
	},
	resetPasswordMessage: {
		da: 'Indtast din e-mail for at nulstille dit password.',
		en: 'Enter your e-mail to reset your password.'
	},
	gameCode: {
		da: 'Spilkode',
		en: 'Game code'
	},
	groupName: {
		da: 'Gruppenavn',
		en: 'Group name'
	},
	selectAGroup: {
		da: 'Vælg gruppe',
		en: 'Choose group'
	},
	createGroup: {
		da: 'Opret gruppe',
		en: 'Create group'
	},
	newGroup: {
		da: 'Ny gruppe',
		en: 'New group'
	},
	writeGroupName: {
		da: 'Navngiv jeres gruppe',
		en: 'Name your group'
	},

	email: {
		da: 'E-mail',
		en: 'E-mail'
	},
	reset: {
		da: 'Gendan',
		en: 'Reset'
	},
	backToLogin: {
		da: 'Tilbage til login',
		en: 'Back to login'
	},
	password: {
		da: 'Password',
		en: 'Password'
	},
	repeatPassword: {
		da: 'Gentag password',
		en: 'Repeat password'
	},
	forgottenPassword: {
		da: 'Glemt password',
		en: 'I forgot my password'
	},
	createUser: {
		da: 'Ny bruger',
		en: 'New user'
	},
	create: {
		da: 'Opret',
		en: 'Create'
	},
	hasAnswered: {
		da: '% har svaret',
		en: '% have answered'
	},

	groupWarningText: {
		da: `En eller flere grupper mangler stadig at gennemføre hele forløbet.
			<br /><br />Er du sikker på, du vil fortsætte?`,
		en: `One or more groups have not completed the game yet.
			<br /><br />Are you sure you want to continue?`
	},
	yesContinue: {
		da: 'Ja, fortsæt',
		en: 'Yes, continue'
	},
	noCancel: {
		da: 'Nej, afbryd',
		en: 'No, cancel'
	},

	no: {
		da: 'Nej',
		en: 'No'
	},
	yes: {
		da: 'Ja',
		en: 'Ja'
	},
	answers: {
		da: 'Svar',
		en: 'Answers'
	},

	ok: {
		da: 'OK',
		en: 'OK'
	},
	back: {
		da: 'Tilbage',
		en: 'Back'
	},
	continue: {
		da: 'Videre',
		en: 'Next'
	},
	next: {
		da: 'Næste',
		en: 'Next'
	},
	results: {
		da: 'Resultater',
		en: 'Results'
	},
	viewAnswers: {
		da: 'Se svar',
		en: 'View answers'
	}

}

const statsTexts = {
	backBtn: {
		da: 'Tilbage til facilitator',
		en: 'Back to facilitator'
	},
	stats: {
		da: 'Statistik',
		en: 'Statistics'
	},
	period: {
		da: 'Periode',
		en: 'Period'
	},
	to: {
		da: 'til',
		en: 'to'
	},
	facilitators: {
		da: 'Nye facilitatorer i perioden',
		en: 'New facilitators in period'
	},
	startedGames: {
		da: 'Startede spil',
		en: 'Started games'
	},
	finishedGames: {
		da: 'Afsluttede spil',
		en: 'Finished games'
	},
	surveyAnswers: {
		da: 'Survey-svar i alt',
		en: 'Total numbe of survey answers'
	},
	startedGroups: {
		da: 'Grupper',
		en: 'Groups'
	},
	finishedGroups: {
		da: 'Gennemførte grupper',
		en: 'Completed groups'
	},
	themes: {
		da: 'Temaer',
		en: 'Themes'
	},
	theme: {
		da: 'Tema',
		en: 'Theme'
	},
	surveys: {
		da: 'Surveys',
		en: 'Surveys'
	},
	questions: {
		da: 'Spørgsmål',
		en: 'Questions'
	}
}
export default {
	errors: errorTexts,
	pages: pageTexts,
	group: groupTexts,
	cookies: cookieTexts,
	general: generalTexts,
	stats: statsTexts
}